import { render, staticRenderFns } from "./NbSupervisorPc.vue?vue&type=template&id=54f3f5ab"
import script from "./NbSupervisorPc.vue?vue&type=script&lang=js"
export * from "./NbSupervisorPc.vue?vue&type=script&lang=js"
import style0 from "./NbSupervisorPc.vue?vue&type=style&index=0&id=54f3f5ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports